import { Stack, ChipProps } from "@mui/material";
import { DisplayZoneValue } from "./types";
import { behaviors, triggers } from "./SmartalarmBoard";
import ZoneChip from "../ZoneView";

interface PZZoneViewProps extends ChipProps {
  zone: DisplayZoneValue;
}

const PZZoneView = ({ zone, ...chipProps }: PZZoneViewProps) => {
  const behavior = behaviors.find((behavior) => behavior.value === zone?.behavior?.toString(2));
  const trigger = triggers.find((trigger) => trigger.value === zone?.trigger);
  return (
    <Stack key={zone.uuid} direction="row" sx={{ flexWrap: "wrap" }}>
      <ZoneChip key={zone.uuid} zoneColor={behavior?.color || trigger?.color} icon={behavior?.icon || trigger?.icon} zone={zone} chipProps={chipProps} />
    </Stack>
  );
};

export default PZZoneView;
